/**
 * Supabaseクライアント
 * ブラウザ環境でのSupabase接続設定
 */

import { createBrowserClient } from '@supabase/ssr'

import { getEnv, validateEnv } from '@/shared/lib/env'

validateEnv()

const supabaseUrl = getEnv('VITE_SUPABASE_URL')
const supabaseAnonKey = getEnv('VITE_SUPABASE_ANON_KEY')

let clientInstance: any = null

export function createClient() {
  if (clientInstance) {
    return clientInstance
  }

  clientInstance = createBrowserClient(
    supabaseUrl,
    supabaseAnonKey,
    {
      db: {
        schema: 'public'
      },
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
        flowType: 'pkce'
      },
      global: {
        headers: {
          'x-my-custom-header': 'genbaflow-app',
        },
      },
      realtime: {
        params: {
          eventsPerSecond: 10,
        },
      },
    }
  )

  if (typeof window !== 'undefined') {
    setTimeout(() => {
      clientInstance.auth.getSession().catch(() => {
        // エラーは無視（事前確立目的のため）
      })
    }, 100)
  }

  return clientInstance
}

export const supabase = createClient()
